import type { NewChargeAttribution } from '../components/SettleChargeAttribution';

/**
 * How a new charge got its encounter, for analytics. The same values as
 * payment_request_sent's `new_charge_attribution` (gdn-3086), so Add Charges
 * and the Collect payment composer read as one measure (gdn-4177).
 */
export type ChargeAttributionSource = 'context' | 'encounter_selected' | 'account_explicit';

/** Undefined only while the biller has not answered. */
export const chargeAttributionSourceOf = (
  contextEncounterId: string | null | undefined,
  attribution: NewChargeAttribution | null,
): ChargeAttributionSource | undefined => {
  if (contextEncounterId) return 'context';
  if (attribution?.kind === 'encounter') return 'encounter_selected';
  if (attribution?.kind === 'account') return 'account_explicit';
  return undefined;
};

/**
 * The encounter a new charge lands on: the composer's own context when it
 * has one, otherwise the biller's answer. Null is account-level.
 */
export const chargeEncounterIdOf = (
  contextEncounterId: string | null | undefined,
  attribution: NewChargeAttribution | null,
): string | null =>
  contextEncounterId ?? (attribution?.kind === 'encounter' ? attribution.encounterId : null);
